export const PRIMARY_MENU_PAGES = [
  { icon: 'people', title: 'Teams', link: '/teams' },
  { icon: 'calendar', title: 'Matches', link: '/match-schedule' },
  { icon: 'list', title: 'Event', link: '/event-rankings' },
  // { icon: 'list-box', title: 'District', link: '/district-rankings' },
  { icon: 'clipboard', title: 'Scouting', link: '/scouting' },
]

export const THEMES = {
  dark: {
    primary: '#484C52',
    secondary: '#5DD39E',
    tertiary: '#348AA7',
    dark: '#ffffff',
    medium: '#513B56',
    light: '#36393F',
    warning: '#ff3d3d'
  },
  light: {
    primary: '#ededdb',
    secondary: '#aea4bf',
    tertiary: '#8f6593',
    dark: '#6e4552',
    medium: '#BCE784',
    light: '#e3e4db',
    warning: '#ff3d3d'
  },
  amoled: {
    primary: '#36393F',
    secondary: '#348AA7',
    tertiary: '#5DD39E',
    dark: '#ffffff',
    medium: '#484C52',
    light: '#000000',
    warning: '#ff3d3d'
  }
}

export const STAT_NAMES = [
  'Match',
  'Scout<br/>Name',
  'Driver<br/>Station',
  'Starting<br/>Point',
  'HAB<br/>Level',
  'Result',
  'Interference',
  'Plays<br/>Defense',
  'Cargo<br/>Left',
  'Cargo<br/>Right',
  'Hatches<br/>Left',
  'Hatches<br/>Right',
  'Climb',
  'Driver',
  'Stability',
  'Penalties'
]
